import { ChangeDetectionStrategy, Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { SystemDefaultColorDirective } from '../../common/directives/system-default-color/system-default-color.directive';

@Component({
  selector: 'lib-auth',
  imports: [RouterOutlet],
  templateUrl: './auth.component.html',
  styleUrl: './auth.component.scss',
  changeDetection: ChangeDetectionStrategy.Eager,
  hostDirectives: [SystemDefaultColorDirective],
})
export class AuthComponent {}
